<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-make p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Make
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://www.make.com/en"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a Make
          </a>
        </small>
      </div>
      <hr />
      <form-group
        :disabled="form.id != null"
        slim
        select
        id="product-select"
        label="Nome do produto"
        v-model="form.product_id"
        placeholder="Selecionar produto..."
        :options="products.map(({ id, name }) => ({ id, name }))"
      />
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <form-group
        label="URL"
        id="url"
        v-model="form.url"
        :errors="errors.url"
        placeholder="Digite a URL..."
      />
      <action-dispatcher action="integration/getTypeEvents">
        <form-group
          select
          multiple
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          placeholder="Selecionar eventos..."
          :options="typeEvents"
        />
      </action-dispatcher>
      <div class="d-flex justify-content-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "description", "events", "name"],
        {
          events: [],
          name: "make"
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
        this.form.product_id = v.events[0].product_id;
      }
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return this.form.events.length && this.form.product_id && this.form.url;
    }
  },
  methods: {
    clear() {
      this.form = { name: "make", events: [] };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      // if (
      //   this.form.url.indexOf("https://") == -1 ||
      //   this.form.url.indexOf(".com") == -1
      // ) {
      //   this.$message.warning("Digite uma url válida");
      //   this.errors = {
      //     ...this.errors,
      //     url: ["Digite uma url válida"]
      //   };
      //   return;
      // }

      this.loading = true;
      let data = { ...this.form };
      data.events = data.events.map(e => {
        return { event: e };
      });
      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.loading = false;
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-make {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
